import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { isNil } from 'lodash';
import { filter, map, Observable, Subject, takeUntil, tap } from 'rxjs';
import { getFailureMessageRxOp } from '@geekbears/gb-ngrx-stack-base';
import { ModalComponent, NotificationsService } from '@geekbears/ngx-gb-ui-kit';

import {
  CompanyActions,
  contactCompanySuccessAction,
  deleteCompanyFailureAction,
  deleteCompanySuccessAction,
  removeMemberFailureAction,
  removeMemberSuccessAction,
  sendInvoiceFailureAction,
  contactCompanyLoadingSelector,
  deleteCompanyLoadingSelector,
} from '@modules/super-admin/company/application';
import { Company } from '@modules/super-admin/company/domain';
import { AccountSetupCompleteModal } from '../account-setup-complete/account-setup-complete.modal';

@Component({
  selector: 'app-company-modals',
  templateUrl: './company-modals.component.html',
  styleUrls: ['./company-modals.component.scss'],
})
export class CompanyModals extends ModalComponent implements OnInit, OnDestroy {
  /**
   * @destroy$ is used to unsubscribe from all subscriptions
   */
  destroy$: Subject<void> = new Subject();
  modalType: string = '';
  company!: Company;
  member: any;
  form!: FormGroup;
  deleteCompanyLoading$: Observable<boolean | any>;
  contactCompanyLoading$: Observable<boolean | any>;

  constructor(
    private store$: Store,
    private actions$: Actions,
    @Inject(MAT_DIALOG_DATA) data: any,
    private notificationsService: NotificationsService,
    private dialogRef: MatDialogRef<AccountSetupCompleteModal>,
    private fb: FormBuilder,
    private notificationService: NotificationsService,
    private router: Router
  ) {
    super();
    if (data) {
      this.modalType = data.modalType;

      if (data.company) {
        this.company = data.company;
      }
      if (data.member) {
        this.company = data.member.company;
        this.member = data.member;
      }
    }
    this.form = this.fb.group({
      message: [''],
    });
    this.contactCompanyLoading$ = this.store$.select(
      contactCompanyLoadingSelector
    );
    this.deleteCompanyLoading$ = this.store$.select(
      deleteCompanyLoadingSelector
    );
  }

  ngOnInit(): void {
    this.onEmailSuccessfullySent();
    this.onFailureActions();
    this.actions$
      .pipe(
        ofType(deleteCompanySuccessAction),
        filter((action) => {
          return !isNil(action.response);
        }),
        map((action) => {
          if (action) this.modalType = 'deleteCompanySuccess';
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType(removeMemberSuccessAction),
        filter((action) => {
          return !isNil(action.response);
        }),
        map((action) => {
          if (action) {
            this.notificationService.success('Member successfully removed', {
              duration: 3000,
              icon: 'check-circle',
            });
            this.closeModal();
            this.router.navigateByUrl(
              `dashboard/company/details/${this.company.id}`
            );
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
  onEmailSuccessfullySent() {
    this.actions$
      .pipe(
        ofType(contactCompanySuccessAction),
        filter((action) => {
          return !isNil(action.response);
        }),
        map((action) => {
          if (action) this.modalType = 'emailSent';
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  closeModal() {
    this.dialogRef.close();
  }
  deleteCompany() {
    this.store$.dispatch(
      CompanyActions.deleteCompany({
        companyId: this.company.id,
      })
    );
  }
  onFailureActions() {
    this.actions$
      .pipe(
        ofType(
          deleteCompanyFailureAction,
          removeMemberFailureAction,
          sendInvoiceFailureAction
        ),
        map((action) => {
          return action.failure;
        }),
        getFailureMessageRxOp(),
        tap((errorMessage) => {
          if (errorMessage) {
            this.notificationsService.error(errorMessage, {
              duration: 5000,
              icon: 'alert-outline',
            });
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
  removeMember() {
    this.store$.dispatch(
      CompanyActions.removeMember({
        memberId: this.member.id,
      })
    );
  }
  sendInvoice() {
    this.store$.dispatch(
      CompanyActions.sendInvoice({
        companyId: this.company.id,
      })
    );
  }

  contactCompany() {
    this.store$.dispatch(
      CompanyActions.contactCompany({
        companyId: this.company.id,
      })
    );
  }
}
